export default {
    uid:state => state.uid,
    currentPickupInfo:state => state.currentPickupInfo
}